// Shared client-platform detection. Extracted from InstallPrompt so the
// push-notification code shares one copy of the iOS/standalone logic.

export const isStandalone = (): boolean => {
  if (typeof window === 'undefined') return false;
  const iosStandalone =
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true;
  const displayStandalone = window.matchMedia?.('(display-mode: standalone)').matches ?? false;
  return iosStandalone || displayStandalone;
};

export const isIosSafari = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  // iPad on iPadOS reports as Macintosh; detect via touch points.
  const isIpadOs = /Macintosh/.test(ua) && (navigator.maxTouchPoints ?? 0) > 1;
  const isIos = /iPhone|iPad|iPod/.test(ua) || isIpadOs;
  if (!isIos) return false;
  // Other iOS browsers are WebKit wrappers that can't add to home screen.
  const isOtherIosBrowser = /CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);
  return !isOtherIosBrowser;
};

export const isPushSupported = (): boolean => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
};
